import styled from 'styled-components'

export const Wrapper = styled.div<{
  axis: 'horizontal' | 'vertical'
  justify?: 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around'
}>`
  align-items: center;
  display: flex;
  flex-direction: ${p => (p.axis === 'horizontal' ? 'row' : 'column')};
  flex-wrap: wrap;
  gap: 0.75rem;
  justify-content: ${p => p.justify};
`
